Date.prototype.getDatetimeBySlot = function (step) {
	let date = new Date(this);

	date.setHours(0,0,0,0);

	let time       = this.valueOf() - date.valueOf();
	let countSteps = Math.ceil(time / 1000 / 60 / step);
	let slotTime   = countSteps * step * 60 * 1000;

	return new Date(date.valueOf() + slotTime);
};

Date.prototype.addMinutesToDatetime = function (minutes) {
	let date = new Date(this);

	date.setHours(
		this.getHours(),
		this.getMinutes() + minutes,
		this.getSeconds(),
		this.getMilliseconds(),
	);

	return date;
};

Date.prototype.subtractMinutesFromDatetime = function (minutes) {
	let date = new Date(this);

	date.setHours(
		this.getHours(),
		this.getMinutes() - minutes,
		this.getSeconds(),
		this.getMilliseconds(),
	);

	return date;
};